import { getHealthColor } from '../utils';

const HealthLegend = () => {
	const scale = [
		{ range: '0% - 35%', value: 0 },
		{ range: '35% - 55%', value: 35 },
		{ range: '55% - 75%', value: 55 },
		{ range: '75% - 85%', value: 75 },
		{ range: '85% - 100%', value: 85 },
	];

	return (
		<div className="flex items-center space-x-6">
			<span className="text-sm text-gray-600">Health Scale:</span>
			{scale.map((item, index) => (
				<div key={index} className="flex items-center space-x-2">
					<div
						className="w-3 h-3 rounded-full"
						style={{ backgroundColor: getHealthColor(item.value) }}
					/>
					<span className="text-xs text-gray-600">{item.range}</span>
				</div>
			))}
		</div>
	);
};

export default HealthLegend;
